export default "__VITE_ASSET__8c8d2a48__"